import React from 'react'

const TemPlates = () => {
  return (
    <div>TemPlates</div>
  )
}

export default TemPlates